<div class="dashboard-container">
  <div class="row">
    <div class="ui-g-12">
      <table>
        <tr>
          <td class="heading-expiry">{{ 'app.ui-messages.license-valid-until' | translate }}:</td>
          <td *ngIf="concession && concession.expiration_date">{{ concession.expiration_date }}</td>
        </tr>
      </table>
      <table>
        <tr *ngIf="isDocumentUploaded">
          <td>
            <div class="ui-g-12 margin-align text-center">
              <button
                pButton
                type="button"
                icon="pi pi-download"
                iconPos="left"
                [label]="'download-button-label' | translate"
                class="margin-align"
                (click)="downloadLicense()"
                *ngIf="concession && concession.status !== ''"
                [disabled]="concession.status !== status.issued && concession.status !== status.partially_issued"></button>
              <button
                pButton
                type="button"
                icon="pi pi-check"
                iconPos="left"
                [label]="'renewal-button-label' | translate"
                (click)="renewLicense()"
                *ngIf="concession && concession.status !== ''"></button>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="ui-g-12 margin-align text-center" *ngIf="concession && concession.status !== ''">
              {{ 'lookup.sk_concession_status.options.' + concession.status + '.name' | translate }}
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<p-confirmDialog
  #renewConcessionConfirmDialog
  icon="pi pi-info-circle"
  message="{{ 'license.confirm-renewal-message' | translate }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="renewConcessionConfirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="renewConcessionConfirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>
<app-loader *ngIf="isLoading"></app-loader>
